const NUMBER_LOCALE = 'en-us';
const formatToUsd = (value: number, fraction = 2) => {
    return Intl.NumberFormat(NUMBER_LOCALE, {
        minimumFractionDigits: fraction,
        currency: 'USD',
        style: 'currency',
    }).format(value);
};

const formatToPercent = (
    value: number,
    minimumFractionDigits = 0,
    maximumFractionDigits = 2,
) => {
    return Number(value / 100).toLocaleString(NUMBER_LOCALE, {
        style: 'percent',
        minimumFractionDigits,
        maximumFractionDigits,
    });
};

type CurrencyFormatterOptions = {
    fraction?: number;
    currencyMnemonic: string;
    locale?: string;
};

const currencyFormatter = (
    value: number,
    options?: CurrencyFormatterOptions,
) => {
    const {
        fraction = 2,
        currencyMnemonic,
        locale = NUMBER_LOCALE,
    } = options || {};

    return `${Intl.NumberFormat(getLocaleForNumberFormat(locale), {
        minimumFractionDigits: fraction,
    }).format(value)} ${currencyMnemonic || ''}`;
};

const getSeparatorsByLocale = (
    locale: string,
): {
    thousands: string;
    decimal: string;
} => {
    const numberFormat = new Intl.NumberFormat(
        getLocaleForNumberFormat(locale),
    );

    return {
        thousands: numberFormat.format(1111).replace(/1/g, ''),
        decimal: numberFormat.format(1.1).replace(/1/g, ''),
    };
};

const getLocaleForNumberFormat = (locale: string) => {
    return locale === 'es' ? 'fr' : locale;
};

const formatThousandSeparator = (
    value: number,
    // eslint-disable-next-line default-param-last
    minimumFractionDigits = 2,
    maximumFractionDigits?: number,
) => {
    return Number(value).toLocaleString(NUMBER_LOCALE, {
        minimumFractionDigits,
        maximumFractionDigits,
    });
};

export const formatNumberWithDivider = (
    number: number,
    divider = ',',
): string => {
    const regex = /\B(?=(\d{3})+(?!\d))/g;

    return number.toString().replace(regex, divider);
};

export const NumberHelper = {
    formatToUsd,
    formatToPercent,
    currencyFormatter,
    getSeparatorsByLocale,
    formatThousandSeparator,
    formatNumberWithDivider,
};
